// src/services/godown.service.js
import api from './api';

const godownService = {
  // Create godown
  createGodown: async (godownData) => {
    try {
      const response = await api.post('/godowns', godownData);
      return response.data;
    } catch (error) {
      console.error('Error creating godown:', error);
      throw error;
    }
  },

  // Get all godowns (paginated)
  getGodowns: async (page = 1, limit = 10, search = '') => {
  try {
    const params = { page, limit };
    if (search) params.search = search;
    const response = await api.get('/godowns', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching godowns:', error);
    throw error;
  }
},

  // Get godowns by region (for dropdowns)
  getGodownsByRegion: async (regionId) => {
    try {
      const response = await api.get(`/godowns/region/${regionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching godowns by region:', error);
      throw error;
    }
  },

  // Get godown by ID
  getGodownById: async (id) => {
    try {
      const response = await api.get(`/godowns/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching godown:', error);
      throw error;
    }
  },

  // Update godown
  updateGodown: async (id, godownData) => {
    try {
      const response = await api.post(`/godowns/${id}`, godownData);
      return response.data;
    } catch (error) {
      console.error('Error updating godown:', error);
      throw error;
    }
  },

  // Delete godown
  deleteGodown: async (id) => {
    try {
      const response = await api.delete(`/godowns/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting godown:', error);
      throw error;
    }
  },
};

export default godownService;